<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GPSBSB/images/cover.jpg?1703000871537" alt="This image is the cover for the book Ensign in Italy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ensign in Italy
      </h1>
      <p class="bookDescription body article font2">
        <p>In 1943, aged 18, Philip Brutton relinquished his place at Cambridge to volunteer for the Welsh Guards. He was commissioned the same year and was Ensign of the Guard as St James's Palace when a near miss by the Luftwaffe hit and badly damaged the surrounding area. At 19, in early 1944, he was sent to Italy where he joined his Regiment and was soon on patrol in the dead-man's-land of the Cassino ruins, threading his way nightly through the minefields, under constant threat of enemy attack, shelling and mortaring. He survived to fight with the 3rd Battalion Welsh Guards as a young battle-hardened platoon commander throughout the major encounters of the Italian campaign involving 1st Guards' Brigade. In Austria, under orders, he handed over the Croatian Government and then 2000 men plus their families to their communist executioners: the Great Betrayal. A regular officer, he was stationed in Palestine before the end of the British Mandate, and after a period with The Prince of Wales's Company, 1st Battalion Welsh Guards, he became a Staff Captain at Headquarters 1st Guards' Brigade, aged 21.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Philip Burton
      </h2>
      
      <p class="authorDescription body article">Philip Burton is an author and historian.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Leo Cooper
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?55c6440b